import { PageMeta } from "@/components/common/Seo/PageMeta"
import DatasharePage from "@/components/products/datashare/DatasharePage"
import { ProductSchema } from "@/components/products/ProductSchema"

const index = () => (
  <>
    <ProductSchema id="datashare" />
    <PageMeta
      meta={{
        title: "Datashare for BigQuery and Snowflake",
        description:
          "Query the data layer behind every Token Terminal product directly in your own BigQuery or Snowflake warehouse. Contact us to set up a Datashare for your team.",
      }}
    />
    <DatasharePage />
  </>
)

export default index
